import PhoneNumber from 'awesome-phonenumber';

class PhoneInputFieldController {
  constructor($scope) {
    'ngInject';
    this.$scope = $scope;
    this.fullNumber = '';
    this.initializeFromModel();
  }

  initializeFromModel() {
    // Kombiniere die separaten Felder zu einer Anzeige-Nummer
    if (this.landModel || this.vorwahlModel || this.nummerModel) {
      const land = this.landModel || '';
      const vorwahl = this.vorwahlModel || '';
      const nummer = this.nummerModel || '';
      
      if (land || vorwahl || nummer) {
        if (land) {
          // Internationale Nummer
          this.fullNumber = `+${land} ${vorwahl} ${nummer}`.trim();
        } else {
          // Deutsche Nummer ohne Ländercode
          const prefix = vorwahl && !vorwahl.startsWith('0') ? '0' : '';
          this.fullNumber = `${prefix}${vorwahl} ${nummer}`.trim();
        }
      }
    }
  }

  onPhoneChange() {
    if (!this.fullNumber) {
      this.clearAllFields();
      return;
    }

    const parsed = this.parseWithAwesome(this.fullNumber);
    this.landModel = parsed.countryCode;
    this.vorwahlModel = parsed.areaCode;
    this.nummerModel = parsed.localNumber;
  }

  parseWithAwesome(input) {
    try {
      // Versuche direktes Parsing
      let phone = PhoneNumber(input);
      
      // Falls nicht gültig, versuche mit Deutschland als Kontext
      if (!phone.isValid()) {
        phone = PhoneNumber(input, 'DE');
      }
      
      if (phone.isValid()) {
        return this.extractPartsFromValidPhone(phone);
      }
      
      // Fallback für ungültige Eingaben
      return this.basicFallbackParsing(input);
      
    } catch (error) {
      console.warn('Phone parsing failed:', error);
      return this.basicFallbackParsing(input);
    }
  }

  extractPartsFromValidPhone(phone) {
    const countryCode = phone.getCountryCode();
    const nationalNumber = phone.getNumber('national').replace(/[\s\-\(\)]/g, '');
    
    // Für Deutschland: intelligente Vorwahl-Extraktion
    if (phone.getRegionCode() === 'DE') {
      // Entferne führende 0 aus nationaler Nummer
      const withoutZero = nationalNumber.startsWith('0') ? nationalNumber.substring(1) : nationalNumber;
      
      // Deutsche Vorwahlen sind meist 2-3 stellig
      if (withoutZero.length >= 6) {
        // Lange Nummer: wahrscheinlich 2-3 stellige Vorwahl
        const areaCode = withoutZero.length > 8 ? withoutZero.substring(0, 3) : withoutZero.substring(0, 2);
        const localNumber = withoutZero.substring(areaCode.length);
        
        return {
          countryCode: countryCode,
          areaCode: areaCode,
          localNumber: localNumber
        };
      }
    }
    
    // Für andere Länder oder kurze deutsche Nummern: einfache Aufteilung
    const withoutCountry = nationalNumber.replace(/^0/, ''); // Entferne führende 0
    
    if (withoutCountry.length <= 6) {
      return {
        countryCode: countryCode,
        areaCode: withoutCountry.substring(0, 2),
        localNumber: withoutCountry.substring(2)
      };
    } else {
      return {
        countryCode: countryCode,
        areaCode: withoutCountry.substring(0, 3),
        localNumber: withoutCountry.substring(3)
      };
    }
  }

  basicFallbackParsing(input) {
    const cleaned = input.replace(/[\s\-\(\)\.]/g, '');
    
    if (cleaned.startsWith('+')) {
      // Internationale Nummer
      const withoutPlus = cleaned.substring(1);
      
      if (withoutPlus.startsWith('49')) {
        // Deutschland
        const remaining = withoutPlus.substring(2);
        return {
          countryCode: '49',
          areaCode: remaining.substring(0, 2),
          localNumber: remaining.substring(2)
        };
      } else if (withoutPlus.startsWith('1')) {
        // USA/Kanada
        const remaining = withoutPlus.substring(1);
        return {
          countryCode: '1',
          areaCode: remaining.substring(0, 3),
          localNumber: remaining.substring(3)
        };
      } else {
        // Andere Länder: erste 2 Ziffern als Ländercode
        return {
          countryCode: withoutPlus.substring(0, 2),
          areaCode: withoutPlus.substring(2, 5),
          localNumber: withoutPlus.substring(5)
        };
      }
    } else {
      // Nationale deutsche Nummer
      const withoutZero = cleaned.startsWith('0') ? cleaned.substring(1) : cleaned;
      return {
        countryCode: '49',
        areaCode: withoutZero.substring(0, 2),
        localNumber: withoutZero.substring(2)
      };
    }
  }

  clearAllFields() {
    this.landModel = '';
    this.vorwahlModel = '';
    this.nummerModel = '';
  }

  formatAsYouType() {
    if (!this.fullNumber) return;

    try {
      let phone = PhoneNumber(this.fullNumber);
      
      if (!phone.isValid()) {
        phone = PhoneNumber(this.fullNumber, 'DE');
      }
      
      if (phone.isValid()) {
        this.fullNumber = phone.getNumber('international');
      }
      
    } catch (error) {
      // Ignoriere Formatierungsfehler
    }
  }

  isValidPhoneNumber() {
    if (!this.fullNumber) return false;
    
    try {
      let phone = PhoneNumber(this.fullNumber);
      
      if (!phone.isValid()) {
        phone = PhoneNumber(this.fullNumber, 'DE');
      }
      
      return phone.isValid();
      
    } catch (error) {
      return false;
    }
  }

  getFormattedExample() {
    return '+49 30 12345678, +1 555 123-4567, 030 12345678';
  }
}

function phoneInputField() {
  return {
    restrict: 'E',
    scope: {
      landModel: '=',
      vorwahlModel: '=',
      nummerModel: '=',
      label: '@',
      required: '=',
      placeholder: '@',
      fieldName: '@',
      lang: '@'
    },
    controller: PhoneInputFieldController,
    controllerAs: 'ctrl',
    bindToController: true,
    template: `
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <label for="{{ctrl.fieldName}}">{{ctrl.label}}</label>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
        <input 
          type="tel" 
          ng-model="ctrl.fullNumber" 
          ng-change="ctrl.onPhoneChange()"
          ng-blur="ctrl.formatAsYouType()"
          name="{{ctrl.fieldName}}" 
          id="{{ctrl.fieldName}}"
          placeholder="{{ctrl.placeholder || ctrl.getFormattedExample()}}"
          ng-required="ctrl.required"
          style="width: 100%; padding: 5px;"
          autocomplete="tel">
        <small style="color: #666; font-size: 0.9em; display: block; margin-top: 2px;">
          <span ng-if="ctrl.lang === 'en'">Format: {{ctrl.getFormattedExample()}}</span>
          <span ng-if="ctrl.lang === 'de'">Formate: {{ctrl.getFormattedExample()}}</span>
        </small>
        <!-- Versteckte Felder für API-Kompatibilität -->
        <input type="hidden" ng-model="ctrl.landModel" name="{{ctrl.fieldName}}_land">
        <input type="hidden" ng-model="ctrl.vorwahlModel" name="{{ctrl.fieldName}}_vorwahl">
        <input type="hidden" ng-model="ctrl.nummerModel" name="{{ctrl.fieldName}}_nummer">
      </div>
    `,
    link: function(scope, element, attrs, ctrl) {
      // Initialisierung bei Änderungen der ursprünglichen Felder
      scope.$watchGroup(['ctrl.landModel', 'ctrl.vorwahlModel', 'ctrl.nummerModel'], function(newValues, oldValues) {
        if (newValues.some((val, index) => val !== oldValues[index])) {
          ctrl.initializeFromModel();
        }
      });
      
      // Validierung visuell anzeigen
      const inputElement = element.find('input[type="tel"]');
      scope.$watch('ctrl.fullNumber', function(newValue) {
        if (newValue) {
          const isValid = ctrl.isValidPhoneNumber();
          inputElement.toggleClass('error-field', !isValid);
        } else {
          inputElement.removeClass('error-field');
        }
      });
    }
  };
}

export default phoneInputField; 


// WEBPACK FOOTER //
// ./client/app/common/directives/phoneInputField.directive.js